import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { forgottenPassword } from 'lib/store/users/actions';
import ForgottenPasswordPage from './ForgottenPasswordPage';

class ForgottenPasswordPageContainer extends Component {
  static getInitialProps({ query }) {
    return { email: query.email };
  }

  render() {
    return <ForgottenPasswordPage {...this.props} />;
  }
}

export default connect(undefined, (dispatch) =>
  bindActionCreators({ forgottenPassword }, dispatch),
)(ForgottenPasswordPageContainer);
